<template>
  <v-dialog
  v-model="visible"
  max-width="800px"
  persistent
  scrollable>
  <v-card v-if="player" light>
      <v-card-text>
          <v-container>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader light>Nombre</v-subheader>
                <p class="caption ml-3">
                  {{currentPlayerOfficialInfo.first_name}}
                </p>
              </v-flex>
              <v-flex xs4>
                <v-subheader light>Apellido(s)</v-subheader>
                <p class="caption ml-3">
                  {{currentPlayerOfficialInfo.last_name}}
                </p>
              </v-flex>
              <v-flex xs4>
                <v-subheader light>Fecha de nacimiento</v-subheader>
                <p class="caption ml-3">
                  {{currentPlayerOfficialInfo.birth_date || ""}}
                </p>
              </v-flex>
              <v-flex xs4>
                <v-subheader light>Numero</v-subheader>
                <p class="caption ml-3">
                  {{currentPlayerOfficialInfo.player_number || ""}}
                </p>
              </v-flex>
              <v-flex xs4>
                <v-subheader light>Posición</v-subheader>
                <p class="caption ml-3">
                  {{currentPlayerOfficialInfo.position || ""}}
                </p>
              </v-flex>
              <v-flex xs4>
                <v-subheader light>Foto</v-subheader>

                  <v-btn  target="_blank" :href="currentPlayerOfficialInfo.user_photo_medium" v-if="currentPlayerOfficialInfo.user_photo_medium"  color="green" small>Ver imagen</v-btn>
                  <v-btn  target="_blank" :href="currentPlayerOfficialInfo.user_photo" v-if="currentPlayerOfficialInfo.user_photo"  color="green" small>Ver imagen original</v-btn>

              </v-flex>
              <v-flex xs4>
                <v-subheader light>Documento oficial</v-subheader>

                  <v-btn target="_blank" :href="currentPlayerOfficialInfo.document_medium" v-if="currentPlayerOfficialInfo.document_medium"  color="green" small>Ver imagen</v-btn>
                  <v-btn target="_blank" :href="currentPlayerOfficialInfo.document" v-if="currentPlayerOfficialInfo.document"  color="green" small>Ver imagen original</v-btn>


              </v-flex>

            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout class="text-xs-right">
          <v-btn v-on:click="close()" flat color="red">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn  :disabled="!validateBtn"  v-on:click="resolve('accepted')" flat color="green">Validar</v-btn>
          <v-btn  :disabled="!rejectBtn"  v-on:click="resolve('rejected')" color="red">Rechazar</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'PlayerOfficialInfo',
    props: {
        player: { required: true }
    },
    data() {
        return {


        }
    },
    created() {

    },
    mounted(){

    },
    watch:{
      player(val){
        if(val && val.id){
          this.loadOfficialInfo(val.id)
        }
      }
    },
    computed:{
      visible(){
        return this.player != null
      },
      validateBtn(){
        return this.player && (this.player.status_in_tournament == "pending" || this.player.status_in_tournament == "rejected")
      },
      rejectBtn(){
        return this.player && (this.player.status_in_tournament == "pending" || this.player.status_in_tournament == "accepted")
      },
      requireValidation(){
        return this.currentTournament.team_type == 1 && this.currentTournament.team_approval
      },
      ...mapGetters([
        "currentPlayerOfficialInfo",
        "currentTournament"
      ])
    },
    methods: {
      ...mapActions([
        "loadOfficialInfo",
        "resolvePlayerOfficialInfo",
        "currentTournament"
      ]),
      close(){
        this.$emit('close')
      },
      resolve(status){
        let data = {}
        data.playerId = this.player.id
        data.status = status
        data.tournamentId = this.currentTournament.id
        this.resolvePlayerOfficialInfo(data)
        this.close()
      }
    }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/teams/PlayerOfficialInfo.vue